import { get_compute_data_query } from './get_compute_data';
import { get_session_transaction_query } from './get_session_transaction';
import { get_transaction_query } from './get_transaction';
import { get_payment_method_details_query } from './get_payment_method_details';
import { get_payment_method_details_panoramic_query } from './get_payment_method_details_panoramic';
import { get_customer_available_currencies_promocode_last_transaction_query } from './get_customer_currencies_transaction_promocodes_data';
import { get_customer_last_transaction_promocodes_query } from './get_customer_last_transaction_promocodes_data';
import { get_dynamic_options_query } from './get_dynamic_options';
import { get_payment_method_groups_query } from './get_payment_method_groups';
import { get_payment_method_groups_panoramic_query } from './get_payment_method_groups_panoramic';
import { get_withdrawl_requests_query } from './get_withdrawl_requests';
import {
  get_initial_data_panoramic_query,
  get_initial_data_panoramic_active_intent_query,
} from './get_initial_data_panoramic';
import {
  get_initial_data_amount_first_query,
  get_initial_data_amount_first_active_intent_query,
} from './get_initial_data_amount_first';

export const graphQlQueryMapping = {
  get_compute_data: get_compute_data_query,
  get_initial_data_panoramic: get_initial_data_panoramic_query,
  get_initial_data_amount_first: get_initial_data_amount_first_query,
  get_initial_data_panoramic_active_intent: get_initial_data_panoramic_active_intent_query,
  get_initial_data_amount_first_active_intent: get_initial_data_amount_first_active_intent_query,
  get_session_transaction: get_session_transaction_query,
  get_transaction: get_transaction_query,
  get_payment_method_details: get_payment_method_details_query,
  get_customer_currencies_transaction_promocodes_data:
    get_customer_available_currencies_promocode_last_transaction_query,
  get_customer_last_transaction_promocodes_data: get_customer_last_transaction_promocodes_query,
  get_dynamic_options: get_dynamic_options_query,
  get_payment_method_groups: get_payment_method_groups_query,
  get_payment_method_groups_panoramic: get_payment_method_groups_panoramic_query,
  get_gateway_details: get_payment_method_details_query,
  get_gateway_details_panoramic: get_payment_method_details_panoramic_query,
  get_withdrawal_requests: get_withdrawl_requests_query,
};
